import { Router, ActivatedRoute, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@uw/core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Observable, map } from 'rxjs';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { AsyncPipe } from '@angular/common';

/**
 * This component is not being used and can be removed in future.
 * @deprecated
 */
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [MatButton, MatIconButton, MatMenuTrigger, MatMenu, RouterLink, AsyncPipe, TranslateModule]
})
export class HeaderComponent implements OnInit {
  sidenav_toggleClass = 'sidenav-toggled';
  allowGroupTypeSwitch: boolean = false;
  isUserLoggedIn$: Observable<boolean> | undefined;
  isSSOUser: boolean;

  constructor(
    private translateService: TranslateService,
    private router: Router,
    private customNavigationService: CustomNavigationService,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.isSSOUser = this.authService.getUser()?.isSSOUser;
    this.isUserLoggedIn$ = this.authService
      .getUserState()
      .pipe(map((user) => !!user));
  }

  toggleSideBar() {
    const body = document.getElementsByTagName('body')[0];
    const hasClass = body.classList.contains(this.sidenav_toggleClass);
    if (hasClass) {
      body.classList.remove(this.sidenav_toggleClass);
    } else {
      body.classList.add(this.sidenav_toggleClass);
    }
  }

  changeLang(e: Event) {
    e.preventDefault();
    const curLang = this.translateService.currentLang;
    this.authService
      .togglerLangugage(curLang === 'en' ? 'fr' : 'en')
      .subscribe((_data) => {
        localStorage.setItem('lang', curLang === 'en' ? 'fr' : 'en');
        this.translateService.use(curLang === 'en' ? 'fr' : 'en');
        window.location.reload();
      });
  }

  onDonate() {
    this.customNavigationService.navigate(['auth']);
  }

  //Revert before 6.5 changes
  // logout() {
  //   if (this.isSSOUser){
  //     this.authService.sso_logOut();
  //   } else {
  //     this.authService.logOut().subscribe(
  //       _ => this.customNavigationService.navigate(['/'])
  //     );
  //   }
  // }

  logout() {
    this.authService.logOut().subscribe(
      _ => this.customNavigationService.navigate(['/'])
    );
  }

}
